import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { getDefaultLanguage } from '@pedix-workspace/utils';
import { RegistrationSharedService } from '../registration-shared.service';

@Injectable({
  providedIn: 'root',
})
export class RegisterFormGuard  {
  private router = inject(Router);
  private registrationSharedService = inject(RegistrationSharedService);
  private t = inject(TranslocoService);
  
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.hasRequiredQueryParams(route)) {
      const { countryCode } = route.queryParams;
      const defaultLanguage = getDefaultLanguage(countryCode)

      this.t.setActiveLang(defaultLanguage);
      return true;
    }

    document.location.href = '/';
    return false;
  }

  private hasRequiredQueryParams(route) {
    const { countryCode, planType, billingType } = route.queryParams;

    if (!countryCode || !planType || !billingType) {
      return false;
    }

    return (
      this.registrationSharedService.availablesPlan.includes(planType.toUpperCase()) &&
      this.registrationSharedService.availablesBillingTypes.includes(billingType.toUpperCase())
    );
  }
}
